
import React from "react";
import { createBrowserRouter } from "react-router-dom";
import ForgotPassword from "../Components/Login/Forgotpassword";
import Login from "../Components/Login/login";
const PublicRoutes=createBrowserRouter([
    {
        path:"/",
        element:<Login/>
        
    },
    {
        path:"/forgotpassword",
        element:<ForgotPassword/>
        
    },
]);

export default PublicRoutes;